export default class ImgModal {
  constructor(img, trigger = null) {
    this.$img = $(img);
    this.$trigger = trigger ? $(trigger) : this.$img;

    this.$trigger.click(this.open.bind(this));

    this.render();
  }

  render() {
    this.$modal = $('<div class="modal"></div>');

    $('<div class="modal__overlay"></div>').appendTo(this.$modal);

    $('<div class="modal__content"></div>')
      .append('<span class="close"></span>')
      .append(this.$img.clone())
      .appendTo(this.$modal);

    this.$modal.appendTo('body');

    this.$modal.find('.modal__overlay, .close').click(this.close.bind(this));
  }

  open() {
    this.$modal.addClass('modal--open');
  }

  close() {
    this.$modal.removeClass('modal--open');
  }
}



// WEBPACK FOOTER //
// ./scripts/components/ImgModal.js